import React from 'react';

function QualificationsList() 
{
    return (
        <ul className='qualification-list'>
            <li>Be 18 years of age or older (minors need two physician recommendations as well as consent from their legal guardian),</li>
            <li>Be diagnosed with a qualifying medical condition – click here to see a list of qualifying medical conditions,</li>
            <li>Have consent from a physician,</li>
            <li>Be an Illinois state resident with proof of residency.</li>
        </ul>
    )
}

export default QualificationsList;